
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'UISpinner',
  props: {
    color: {
      type: String,
      default: '#38a0db',
    },
    size: {
      type: String,
      default: 'default',
    },
  },
  computed: {
    customCss(): string {
      if (this.size === 'extra-small') return 'ld-xs'
      if (this.size === 'small') return 'ld-sm'
      if (this.size === 'large') return 'ld-lg'
      if (this.size === 'extra-large') return 'ld-xl'
      return 'ld-md'
    },
  },
})
